<template>
  <div style="font-family: sans-serif; width: 210mm; text-align: center;">
    <h3 style="text-transform: uppercase;">
      Potwierdzenie odbioru Usteckiej Karty Mieszkańca w formie fizycznej
    </h3>

    <p>
      Potwierdzam odbiór Usteckiej Karty mieszkańca o numerach:
    </p>

    <div v-for="(collectionPoint, index) of this.collectionPoints" :key="'collectionPoint_' + index">
      <h4>Punkt odbioru: {{ collectionPoint }}</h4>

      <table style="margin: auto; border-collapse: collapse;">
        <thead>
          <tr>
            <th style="border: 1px solid black; padding: 5px 10px;">Lp.</th>

            <th style="border: 1px solid black; padding: 5px 40px;">Numer karty</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(card, index) of cardsByCollectionPoint[collectionPoint]" :key="'card_' + index">
            <td style="text-align: center; border: 1px solid black; padding: 5px;">{{ index + 1 }}.</td>

            <td style="text-align: center; border: 1px solid black; padding: 5px;">
              {{ card.number }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div style="margin-left: 60%; margin-top: 2cm; width: 40%;">
      <div style="border-bottom: 3px dotted black; margin-bottom: 5px;" />

      <div>Data i podpis osoby odbierającej Karty w wersji fizycznej</div>
    </div>
  </div>
</template>

<script>
const noCollectionPoint = 'Brak punktu odbioru';

// @vuese
// Wydruk potwierdzenia odbioru kart
// @group printable
export default {
  props: {
    // Wybrane karty
    cards: {
      type: Array,
      required: true
    }
  },

  computed: {
    collectionPoints() {
      return this.cards
        .map(card => (card.collectionPoint && card.collectionPoint.name) || noCollectionPoint)
        .filter((value, index, collectionPoints) => collectionPoints.indexOf(value) === index);
    },
    cardsByCollectionPoint() {
      const cardsByCollectionPoint = {};
      for (const collectionPoint of this.collectionPoints) {
        cardsByCollectionPoint[collectionPoint] = this.cards.filter(card => {
          if (!card.collectionPoint && collectionPoint === noCollectionPoint) {
            return true;
          }
          return card.collectionPoint && card.collectionPoint.name === collectionPoint;
        });
      }

      if (Object.keys(cardsByCollectionPoint).length) {
        this.$nextTick(() => {
          this.$emit('rendered');
        });
      }

      return cardsByCollectionPoint;
    }
  }
};
</script>
